import Header from "../../Components/header/index";
import "./survey.css";
// import { Rate } from "antd";
import FormatHlper from "../../../Helper/FormatHelper";
import useSurvey from "../../../hooks/useSurvey";
import { useEffect } from "react";
import moment from "jalali-moment";
import FiveStar from "../../../assets/vectors/five_star.png";
import FourStar from "../../../assets/vectors/four_star.png";
import ThreeStar from "../../../assets/vectors/three_star.png";
import TwoStar from "../../../assets/vectors/two_star.png";
import OneStar from "../../../assets/vectors/one_star.png";
import BannerStar from "../../../assets/vectors/banner_star.png";
import DividerImage from "../../../assets/vectors/divider.png";
import FillStar from "../../../assets/vectors/fill-star.png";
import LikeIcon from "../../../assets/vectors/like_icon.png";
import ReportIcon from "../../../assets/vectors/flag_icon.png";
import Layout from "../../../layout";

const Survey = () => {
  const { getSurveys, surveyData } = useSurvey();

  useEffect(() => {
    getSurveys();
  }, []);

  return (
    <Layout>
      <div className="survey">
        <Header title={"امتیازات و نظرات مشتریان"} />
        {/* total */}
        <div className="survey_total_box_wrapper">
          <div className="survey_total_box">
            {/* sub skills */}
            <div>
              {/* skill */}
              <div>
                <div>تخصص</div>
                <div>
                  <img src={BannerStar} alt="star" />
                  <div>
                    {surveyData?.points?.skill
                      ? FormatHlper.toPersianString(
                          Math.round(surveyData?.points?.skill * 2) / 2
                        )
                      : "---"}
                  </div>
                </div>
              </div>
              {/* behavior */}
              <div>
                <div>ظاهر و برخورد</div>
                <div>
                  <img src={BannerStar} alt="star" />
                  <div>
                    {surveyData?.points?.behavior
                      ? FormatHlper.toPersianString(
                          Math.round(surveyData?.points?.behavior * 2) / 2
                        )
                      : "---"}
                  </div>
                </div>
              </div>
              {/* ontime */}
              <div>
                <div>پیگیری و حضور به موقع</div>
                <div>
                  <img src={BannerStar} alt="star" />
                  <div>
                    {surveyData?.points?.ontime
                      ? FormatHlper.toPersianString(
                          Math.round(surveyData?.points?.ontime * 2) / 2
                        )
                      : "---"}
                  </div>
                </div>
              </div>
              {/* fair_price */}
              <div>
                <div>رضایت از هزینه دریافتی</div>
                <div>
                  <img src={BannerStar} alt="star" />
                  <div>
                    {surveyData?.points?.fair_price
                      ? FormatHlper.toPersianString(
                          Math.round(surveyData?.points?.fair_price * 2) / 2
                        )
                      : "---"}
                  </div>
                </div>
              </div>
            </div>
            {/* total */}
            <div>
              <div>
                {Math.round(surveyData?.points?.overall * 2) / 2 >= 0 &&
                Math.round(surveyData?.points?.overall * 2) / 2 < 2 ? (
                  <img src={OneStar} alt="1 star" />
                ) : null}
                {Math.round(surveyData?.points?.overall * 2) / 2 >= 2 &&
                Math.round(surveyData?.points?.overall * 2) / 2 < 3 ? (
                  <img src={TwoStar} alt="2 star" />
                ) : null}
                {Math.round(surveyData?.points?.overall * 2) / 2 >= 3 &&
                Math.round(surveyData?.points?.overall * 2) / 2 < 4 ? (
                  <img src={ThreeStar} alt="3 star" />
                ) : null}
                {Math.round(surveyData?.points?.overall * 2) / 2 >= 4 &&
                Math.round(surveyData?.points?.overall * 2) / 2 < 5 ? (
                  <img src={FourStar} alt="4 star" />
                ) : null}
                {Math.round(surveyData?.points?.overall * 2) / 2 === 5 ? (
                  <img src={FiveStar} alt="5 star" />
                ) : null}
              </div>
              <span>
                {surveyData?.points?.overall !== null &&
                surveyData?.points?.overall !== undefined
                  ? FormatHlper.toPersianString(
                      Math.round(surveyData?.points?.overall * 2) / 2
                    )
                  : "---"}
              </span>
            </div>
            <img src={DividerImage} alt="divider" />
          </div>
        </div>
        {/* comments */}
        <div className="survey_user_comments_wrapper">
          {surveyData?.survey?.map((survey, index) => (
            <div key={index}>
              {/* top section */}
              <div>
                {/* skill */}
                <div>
                  <span>تخصص</span>
                  <img src={FillStar} alt="score" />
                  <span>
                    {survey?.skill
                      ? FormatHlper.toPersianString(
                          Math.round(parseFloat(survey?.skill) * 2) / 2
                        )
                      : "----"}
                  </span>
                </div>
                {/* ontime */}
                <div>
                  <span>پیگیری و حضور به موقع</span>
                  <img src={FillStar} alt="score" />
                  <span>
                    {survey?.ontime
                      ? FormatHlper.toPersianString(
                          Math.round(parseFloat(survey?.ontime) * 2) / 2
                        )
                      : "----"}
                  </span>
                </div>
                {/* behavior */}
                <div>
                  <span>ظاهر و برخورد</span>
                  <img src={FillStar} alt="score" />
                  <span>
                    {survey?.behavior
                      ? FormatHlper.toPersianString(
                          Math.round(parseFloat(survey?.behavior) * 2) / 2
                        )
                      : "----"}
                  </span>
                </div>
                {/* fair_price */}
                <div>
                  <span>رضایت از هزینه دریافتی</span>
                  <img src={FillStar} alt="score" />
                  <span>
                    {survey?.fair_price
                      ? FormatHlper.toPersianString(
                          Math.round(parseFloat(survey?.fair_price) * 2) / 2
                        )
                      : "----"}
                  </span>
                </div>
              </div>
              {/* like button */}
              <button>
                <span>{FormatHlper.toPersianString(17)}</span>
                <img src={LikeIcon} alt="like" />
              </button>
              {/* report button */}
              <button>
                <img src={ReportIcon} alt="report" />
              </button>
              {/* created_at */}
              <div>
                {survey?.created_at
                  ? FormatHlper.toPersianString(
                      moment(survey?.created_at)
                        .locale("fa")
                        .format("YYYY/MM/DD")
                    )
                  : "-----"}
              </div>
              {/* comment */}
              <div>
                {survey?.description
                  ? FormatHlper.toPersianString(survey?.description)
                  : ""}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};
export default Survey;
